import { ColorLabelProviderAbstract } from './colorlabelprovider.service.abstract';

export class ColorLabelProviderServiceDeviation extends ColorLabelProviderAbstract {

  public label(budget: number, actual: number, remaining: number) {
    return ((actual + remaining) - budget);
  }

}
